module.exports = __webpack_public_path__ + "img/emptystate_hammer.f2185d9a.svg";